import { useEffect } from "react";
import { Pagination, Spin } from "antd";
import { SearchBar, TopicCard, Categories, useToast } from "../../components";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { topic, favorites } from "../../store";
import "./explore.css";

const Explore = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const activeTopics = useSelector((state) => state.activeTopics);
  const {
    data: topicData = [],
    categoryId,
    pagination,
    isLoading,
  } = activeTopics;
  const { topicMap } = useSelector((state) => state.favorites);

  useEffect(() => {
    dispatch(favorites.fetchFavorites());
  }, [dispatch]);

  const handlePageChange = (page) => {
    dispatch(topic.goToPage(page));
  };

  const handleTopicClick = (topicId) => {
    navigate(`/topic/${topicId}`);
  };

  const handleToggleFavorite = (topicId) => {
    const favoriteDocId = topicMap[topicId];
    if (favoriteDocId && favoriteDocId !== "pending") {
      dispatch(
        favorites.removeFavorite({
          favoriteDocId,
          itemId: topicId,
          type: "TOPIC",
        })
      ).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          toast.success("Removed from favorites");
        } else if (res.meta.requestStatus === "rejected") {
          toast.error("Failed to remove from favorites");
        }
      });
    } else {
      dispatch(favorites.addFavorite(topicId)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          toast.success("Added to favorites");
        } else if (res.meta.requestStatus === "rejected") {
          toast.error("Failed to add to favorites");
        }
      });
    }
  };

  const topics = topicData.map((t, index) => {
    const tid = t.id || t._id;
    const isFav = !!topicMap[tid] && topicMap[tid] !== "pending";
    const isLoadingFav = topicMap[tid] === "pending";

    return (
      <div
        key={tid}
        className="explore-grid-item"
        style={{ animationDelay: `${index * 0.05}s` }}
      >
        <TopicCard
          topicId={tid}
          logo={t.picture}
          topic={t.name}
          onlineCoaches={t.previewCoaches || []}
          availableCoaches={t.availableCoaches}
          topicDescription={t.description}
          onClick={handleTopicClick}
          isFavorited={isFav}
          favoriteLoading={isLoadingFav}
          onToggleFavorite={() => handleToggleFavorite(tid)}
        />
      </div>
    );
  });

  return (
    <div className="explore-page">
      <SearchBar />
      <Categories />
      <div className="explore-content">
        <div className="explore-header">
          <h1 className="explore-heading">Explore Training</h1>
          <p className="explore-subtitle">
            Discover specialized programs designed to elevate your kinetic
            performance.
          </p>
        </div>
        <Spin spinning={isLoading}>
          <div key={categoryId || "no-category"} className="explore-grid">
            {topics}
          </div>
        </Spin>
        {pagination.totalPages > 0 && (
          <div className="explore-pagination">
            <Pagination
              simple
              current={pagination.currentPage}
              total={pagination.totalItems}
              pageSize={pagination.pageSize}
              onChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Explore;
